import { createUseStyles } from 'react-jss'

export const style = {
  sideBySideChartFilterBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .split-chart-filter-bar-element': {
      width: 482,
      display: 'flex',
      justifyContent: 'center'
    }
  }
}

export const useStyles = createUseStyles(style)
